import { addToDate } from '@travelata-libs/utils';
import Cookies from 'js-cookie';
import getWildcardDomain from '@/shared/lib/getWildcardDomain';
const LEAD_COOKIE_KEY = 'lead_session';
const LEAD_EXPIRATION_HOURS = 24;

export const setLeadCookie = (): void => {
  Cookies.set(LEAD_COOKIE_KEY, 'active', {
    domain: getWildcardDomain(),
    path: '/',
    expires: addToDate(new Date(), { hours: LEAD_EXPIRATION_HOURS }),
  });
};

export const getLeadCookie = (): string | undefined => {
  return Cookies.get(LEAD_COOKIE_KEY);
};

export const checkLeadSession = (): boolean => {
  return !!getLeadCookie();
};
